import { ReactNode } from "react";
import ArrowUpRed from "@Icons/ArrowUpRed";
import ArrowUpGreen from "@Icons/ArrowUpGreen";
import ArrowDownRed from "@Icons/ArrowDownRed";
import ArrowDownGreen from "@Icons/ArrowDownGreen";
import { FactRow } from "../types";
import { resolveCopy } from "./neighbourhoodHelpers";
import { renderBoldText } from "./renderBoldText";
import renderRichText from "./renderRichText";

type TFunction = Parameters<typeof resolveCopy>[0];

/** The row's sentence: the backend's text when present, else today's Tolgee copy. */
export const factStatement = (t: TFunction, fact: FactRow): string =>
  fact.text ?? resolveCopy(t, fact.key, fact.params);

/** Backend text carries <b>…</b>; Tolgee copy carries the older <…> markers. */
export const renderFactText = (fact: FactRow, statement: string): ReactNode =>
  fact.text !== undefined ? renderRichText(statement) : renderBoldText(statement);

/**
 * Arrow for a backend row (direction from `trend`, colour from `sentiment`).
 * Returns undefined when the row has no backend sentiment, so the caller keeps
 * its own colour rule.
 */
export const backendTrendIcon = (fact: FactRow): ReactNode | undefined => {
  if (fact.sentiment === undefined) return undefined;
  if (fact.trend === "up") return fact.sentiment === "positive" ? <ArrowUpGreen /> : <ArrowUpRed />;
  if (fact.trend === "down") {
    return fact.sentiment === "negative" ? <ArrowDownRed /> : <ArrowDownGreen />;
  }
  return null;
};
